import { useState, useEffect, RefObject } from 'react';

/**
 * Custom hook to track vertical scroll position
 */
const useScrollPosition = (containerRef?: RefObject<HTMLElement>) => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const scrollElement = containerRef?.current || window;

    const handleScroll = () => {
      if (scrollElement instanceof Window) {
        setScrollY(window.scrollY);
      } else {
        setScrollY(scrollElement.scrollTop);
      }
    };

    scrollElement.addEventListener('scroll', handleScroll);

    handleScroll();

    return () => {
      scrollElement.removeEventListener('scroll', handleScroll);
    };
  }, [containerRef]);

  return scrollY;
};

export default useScrollPosition;
